import React from 'react'
import PropTypes from 'prop-types'
import { Divider, List, ListItem, ListItemText, ListSubheader, makeStyles } from '@material-ui/core'

import DialogWithCloseIcon from '../../../../DialogWithCloseIcon/DialogWithCloseIcon'
import connectedGameDialogStyles from './connectedGameDialog.styles'

// Groups the (already season-sorted) candidate games into contiguous season sections, mirroring the
// previous autocomplete groupBy.
const groupBySeason = (options) => {
  const groups = []
  options.forEach((game) => {
    const seasonName = game.seasonName ?? ''
    let group = groups.find((g) => g.seasonName === seasonName)
    if (!group) {
      group = { seasonName, games: [] }
      groups.push(group)
    }
    group.games.push(game)
  })
  return groups
}

// Modal picker for the federation game a club game connects to. Clicking a row selects it and
// closes — the close icon dismisses without changing the selection.
const ConnectedGameDialog = ({ open, onClose, options, selectedGameId, onSelect, getOptionLabel }) => {
  const useStyles = makeStyles(connectedGameDialogStyles)
  const classes = useStyles()

  const groups = groupBySeason(options)

  return (
    <DialogWithCloseIcon open={open} onClose={onClose} dialogTitle='Select connected game'>
      <List component='nav'>
        {options.length === 0 ? (
          <span className={classes.emptyText}>No connectable games</span>
        ) : (
          groups.map((group, groupIndex) => (
            <div key={group.seasonName}>
              <ListSubheader disableSticky className={classes.subheader}>
                {group.seasonName}
              </ListSubheader>

              {group.games.map((game) => (
                <ListItem
                  button
                  key={game.gameEventId}
                  selected={game.gameEventId === selectedGameId}
                  onClick={() => onSelect(game.gameEventId)}
                >
                  <ListItemText
                    primary={getOptionLabel(game)}
                    primaryTypographyProps={{ className: classes.listItemText }}
                  />
                </ListItem>
              ))}

              {groupIndex !== groups.length - 1 && <Divider />}
            </div>
          ))
        )}
      </List>
    </DialogWithCloseIcon>
  )
}

ConnectedGameDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  selectedGameId: PropTypes.string,
  onSelect: PropTypes.func,
  getOptionLabel: PropTypes.func,
}

export default ConnectedGameDialog
